export enum PersonalizedActionSource {
    Directives = 'Directives',
    Rewards = 'Rewards'
}
